import { createSlice } from "@reduxjs/toolkit";

export const lockerStorageFeesSlice = createSlice({
	name: "lockerStorageFees",
	initialState: {
		searchCriteria: {
			operatorId: localStorage.getItem("user")
				? JSON.parse(localStorage.getItem("user")).operator_id
				: "",
			lockerTypeId: "-1",
			userTypeId: "-1",
			doorSizeId: "-1",
		},
		storageSizeFeeData: {},
		storageTimeFeeData: [],
		userTypeList: [],
		doorSizesList: [],
		lockerTypeList: [],
		storageTimeFeeForm: [],
	},
	reducers: {
		changeCriteriaValue: (state, actions) => {
			const { name, value } = actions.payload;
			state.searchCriteria[name] = value;
		},
		setStorageSizeFeeData: (state, actions) => {
			state.storageSizeFeeData = actions.payload;
		},
		setStorageTimeFeeData: (state, actions) => {
			state.storageTimeFeeData = actions.payload;
		},
		getUserTypeList: (state, actions) => {
			state.userTypeList = actions.payload;
		},
		getLockerTypeList: (state, actions) => {
			state.lockerTypeList = actions.payload;
		},
		getDoorSizesList: (state, actions) => {
			state.doorSizesList = actions.payload;
		},
		addStorageTimeFeeForm: (state, actions) => {
			let tempStorageTimeFeeForm = [...state.storageTimeFeeForm];
			tempStorageTimeFeeForm.push(actions.payload);
			state.storageTimeFeeForm = tempStorageTimeFeeForm;
		},
		changeStorageTimeFeeForm: (state, actions) => {
			const { name, value, id } = actions.payload;
			let tempStorageTimeFeeForm = [...state.storageTimeFeeForm];
			tempStorageTimeFeeForm[id][name] = value;
			state.storageTimeFeeForm = tempStorageTimeFeeForm;
		},
		changeStorageTimeFeeData: (state, actions) => {
			const { name, value, id } = actions.payload;
			let tempStorageTimeFeeData = [...state.storageTimeFeeData];
			tempStorageTimeFeeData[id][name] = value;
			state.storageTimeFeeData = tempStorageTimeFeeData;
		},
		changeStorageSizeFeeData: (state, actions) => {
			const { name, value } = actions.payload;
			let tempStorageSizeFeeData = { ...state.storageSizeFeeData };
			tempStorageSizeFeeData[name] = value;
			state.storageSizeFeeData = tempStorageSizeFeeData;
		},
		clearStorageTimeFeeForm: (state, actions) => {
			state.storageTimeFeeForm = [];
		},
	},
});

// Action creators are generated for each case reducer function
export const {
	getUserTypeList,
	getLockerTypeList,
	getDoorSizesList,
	changeCriteriaValue,
	setStorageSizeFeeData,
	setStorageTimeFeeData,
	addStorageTimeFeeForm,
	changeStorageTimeFeeForm,
	changeStorageTimeFeeData,
	changeStorageSizeFeeData,
	clearStorageTimeFeeForm,
} = lockerStorageFeesSlice.actions;

export default lockerStorageFeesSlice.reducer;
